import { useEffect, useState } from 'react'
import './PageLoadReveal.css'

export default function PageLoadReveal() {
  const [phase, setPhase] = useState('enter')

  useEffect(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduceMotion) {
      setPhase('done')
      return undefined
    }

    // Prevent background scroll while the curtain is up.
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const t1 = setTimeout(() => setPhase('split'), 750)
    const t2 = setTimeout(() => {
      setPhase('done')
      document.body.style.overflow = prevOverflow
    }, 1750)

    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
      document.body.style.overflow = prevOverflow
    }
  }, [])

  if (phase === 'done') return null

  return (
    <div className={`page-reveal page-reveal-${phase}`} role="presentation" aria-hidden="true">
      <div className="page-reveal-panel page-reveal-panel-left" />
      <div className="page-reveal-panel page-reveal-panel-right" />
      <div className="page-reveal-mark">
        <img src="/images/logo/logo.webp" alt="" className="page-reveal-logo" />
        <span className="page-reveal-name">AS Elite Gatherings</span>
        <span className="page-reveal-line" />
      </div>
    </div>
  )
}
